import React from 'react';
import { Stack, Text } from '@alefeducation/ui-elements-library-core';
import styled, { css } from 'styled-components';
import { useAvatarUploadContext } from './context';
import {
  FILE_NAME,
  CATEGORY,
  GENDER,
  STATUS,
  EXPIRY_DATE,
  ORGANIZATION,
  STAR_COST,
  TENANT,
} from '../../utils/constants';
import { defaultHeaderStyles } from '../../styles/Common';
import { Checkbox } from '../Checkbox';

export const AVATAR_HISTORY_ACTIONS = 'AVATAR_HISTORY_ACTIONS';

const colTitles = [
  { title: 'select-all', className: 'col-select-all', width: '5%' },
  { title: FILE_NAME, className: 'col-file-name', width: '15%' },
  { title: STAR_COST, className: 'col-star-cost', width: '10%' },
  { title: TENANT, className: 'col-tenant', width: '10%' },
  { title: ORGANIZATION, className: 'col-organization', width: '15%' },
  { title: CATEGORY, className: 'col-category', width: '10%' },
  { title: GENDER, className: 'col-gender', width: '10%' },
  { title: STATUS, className: 'col-status', width: '10%' },
  { title: EXPIRY_DATE, className: 'col-expiry-date', width: '10%' },
  { title: AVATAR_HISTORY_ACTIONS, className: 'col-actions', width: '5%' },
];

const getWidth = (name: string) =>
  colTitles.find((c) => c.title === name)?.width;

const AvatarHistoryColHeader = () => {
  const { toggleAvatar, areAllSelected } = useAvatarUploadContext();

  return (
    <StyledHeader data-testid="avatar-history-header-col">
      {colTitles.map((column) => (
        <StyledStack
          width={column.width}
          className={column.className}
          flexDirection="column"
          justifyContent="center"
          key={column.title}
          name={column.title}
        >
          {column.title === 'select-all' ? (
            <span data-testid="select-all-checkbox">
              <Checkbox
                value="value"
                checked={areAllSelected}
                onChange={() => toggleAvatar('all')}
              />
            </span>
          ) : (
            <Text variant="body-large" color="primary.100" weight="bold">
              {column.title === AVATAR_HISTORY_ACTIONS ? '' : column.title}
            </Text>
          )}
        </StyledStack>
      ))}
    </StyledHeader>
  );
};

export default AvatarHistoryColHeader;
const centerAlign = [CATEGORY, STATUS, EXPIRY_DATE, STAR_COST];

export const StyledStack = styled(Stack)<{ name: string }>`
  width: ${(props: any) => getWidth(props.name)};

  ${(props) =>
    centerAlign.includes(props.name)
      ? css`
          align-items: center;
          justify-content: center;
        `
      : ''}
`;

const StyledHeader = styled.div`
  ${defaultHeaderStyles};
  padding: 24px;
`;
